import { render, staticRenderFns } from "./huodong2.vue?vue&type=template&id=463e0c8e&scoped=true&"
import script from "./huodong2.vue?vue&type=script&lang=js&"
export * from "./huodong2.vue?vue&type=script&lang=js&"
import style0 from "./huodong2.vue?vue&type=style&index=0&id=463e0c8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463e0c8e",
  null
  
)

export default component.exports